import React, { useState, useEffect } from 'react'

interface DashboardData {
  customerCount: number
  itemCount: number
  recentEstimates: number
  pendingInvoices: number
}

const Home: React.FC = () => {
  const [data, setData] = useState<DashboardData>({
    customerCount: 0,
    itemCount: 0,
    recentEstimates: 0,
    pendingInvoices: 0
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadDashboardData()
  }, [])

  const loadDashboardData = async () => {
    try {
      setLoading(true)
      // 各データを非同期で取得
      const [customerResult, itemResult] = await Promise.all([
        window.api.customer.list({ page: 1, limit: 1 }),
        window.api.item.list({ page: 1, limit: 1 })
      ])

      setData({
        customerCount: customerResult.ok ? (customerResult.data as { total: number }).total : 0,
        itemCount: itemResult.ok ? (itemResult.data as { total: number }).total : 0,
        recentEstimates: 0,
        pendingInvoices: 0
      })
    } catch (error) {
      console.error('ダッシュボードデータの読み込みに失敗:', error)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return <div className="page-loading">読み込み中...</div>
  }

  return (
    <div className="page home-page">
      <h2 className="page-title">ダッシュボード</h2>
      <div className="dashboard-grid">
        <div className="dashboard-card">
          <div className="card-icon">👥</div>
          <div className="card-content">
            <div className="card-value">{data.customerCount}</div>
            <div className="card-label">登録顧客数</div>
          </div>
        </div>
        <div className="dashboard-card">
          <div className="card-icon">📦</div>
          <div className="card-content">
            <div className="card-value">{data.itemCount}</div>
            <div className="card-label">登録品目数</div>
          </div>
        </div>
        <div className="dashboard-card">
          <div className="card-icon">📝</div>
          <div className="card-content">
            <div className="card-value">{data.recentEstimates}</div>
            <div className="card-label">今月の見積</div>
          </div>
        </div>
        <div className="dashboard-card">
          <div className="card-icon">💰</div>
          <div className="card-content">
            <div className="card-value">{data.pendingInvoices}</div>
            <div className="card-label">未請求件数</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home
